export default function SignatureSVG({
  className = "",
  delay = 0,
}: {
  className?: string;
  delay?: number;
}) {
  return (
    <div className={`inline-flex flex-col items-start ${className}`} aria-hidden="true">
      {/* Signature text — "John Wick" in Great Vibes font with writing reveal */}
      <span
        className="font-signature text-[var(--color-gold)] animate-write-reveal select-none"
        style={{
          fontSize: "2.8rem",
          lineHeight: 1.5,
          animationDelay: `${delay}s`,
          letterSpacing: "0.01em",
          padding: "0.15em 0 0.15em 0.15em",
        }}
      >
        John Wick
      </span>
      {/* Underline flourish */}
      <span
        className="mt-0.5 block h-[1.5px] w-full animate-underline-reveal rounded-full"
        style={{
          background: "linear-gradient(90deg, var(--color-gold) 0%, transparent 100%)",
          opacity: 0.35,
          animationDelay: `${delay + 1.6}s`,
        }}
      />
    </div>
  );
}
